/// <reference path="wpt.ts" />
/// <reference path="components/componentButtonPalette.ts" />
/// <reference path="components/componentChart.ts" />
/// <reference path="components/componentCQChooser.ts" />
/// <reference path="components/componentCrossReferences.ts" />
/// <reference path="components/componentDataList.ts" />
/// <reference path="components/componentDataTable.ts" />
/// <reference path="components/componentDataTree.ts" />
/// <reference path="components/componentDocTypeSelector.ts" />
/// <reference path="components/componentDocumentProperties.ts" />
/// <reference path="components/componentEFormHandler.ts" />
/// <reference path="components/componentEnvelopes.ts" />
/// <reference path="components/componentFavouriteDocuments.ts" />
/// <reference path="components/componentGoogleMap.ts" />
/// <reference path="components/componentKeywordsBase.ts" />
/// <reference path="components/componentKeywordsSearch.ts" />
/// <reference path="components/componentKeywordsUpload.ts" />
/// <reference path="components/componentKeywordsViewEdit.ts" />
/// <reference path="components/componentLogonHandler.ts" />
/// <reference path="components/componentNotes.ts" />
/// <reference path="components/componentOptionInput.ts" />
/// <reference path="components/componentRecentDocuments.ts" />
/// <reference path="components/componentSavedSearches.ts" />
/// <reference path="components/componentWvActionMenu.ts" />
/// <reference path="components/componentWvAttributes.ts" />
/// <reference path="components/componentWvFilterResultTable.ts" />
/// <reference path="components/componentWvFormHandler.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components";
        /**
         * Widget component base class and any related support
         */
        class ComponentBaseClass {
            constructor(core, container, parent) {
                this._core = null; // Everyone gets to see the core
                this._log = null;
                this._container = null;
                /** holding the parent widget, may be NULL in certain situations */
                this._parent = null;
                this._readyToPresent = false;
                this._waitingToPresent = false;
                // Need some error handlers so owners can pass them in
                this._errorCallback = null;
                this._failCallback = null;
                this._core = core;
                this._log = core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("ComponentBaseClass::constructor");
                this._container = container;
                this._parent = parent;
            }
            set ErrorCallback(callback) {
                this._errorCallback = callback;
            }
            set FailCallback(callback) {
                this._failCallback = callback;
            }
            present() {
                this._log.info("ComponentBaseClass.present()");
                if (!this._readyToPresent)
                    this._waitingToPresent = true;
                else
                    this._present();
            }
            _present() {
                throw new TypeError("Must override method present(): void");
            }
        }
        Widgets.ComponentBaseClass = ComponentBaseClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
